import React from "react";
import { motion } from "framer-motion";

const offerings = [
    "Innovative digital solutions",
    "Expert web & app development",
    "Creative UI/UX design",
    "Scalable technology systems",
    "Strategic growth support for your business success",
];

const ClientSection = () => {
    return (
        <section className="relative overflow-hidden lg:py-[100px] md:py-[80px] py-[60px]">
            <div className="absolute inset-0">
                <img
                    src="/assets/lab/img3.png"
                    alt="background"
                    className="w-full h-full object-cover"
                />
            </div>

            <div className="relative z-10 max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">

                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9 }}
                    viewport={{ once: true, amount: 0.1 }}
                    className="bg-[#FFFFFF] max-w-[785px] w-full lg:px-[60px] lg:py-[55px] sm:p-[40px] px-[20px] py-[30px] shadow-[0_10px_40px_rgba(0,0,0,0.15)] rounded-sm"
                >

                    <div className="flex flex-col lg:flex-row items-start justify-between gap-[24px] sm:gap-[40px]">

                        <motion.div
                            initial={{ opacity: 0, y: -10 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2, duration: 0.7 }}
                            viewport={{ once: true }}
                            variants={{
                                lg: { initial: { opacity: 0, x: -50, y: 0 }, whileInView: { opacity: 1, x: 0, y: 0 } }
                            }}
                            className="max-w-full lg:max-w-[257px] w-full"
                        >
                            <h2 className="text-[#01386A] font-[600] font-sora leading-tight lg:leading-[1.2] text-[20px] lg:text-[30px]">
                                What We Bring to Our Clients
                            </h2>
                        </motion.div>

                        <div className="flex flex-col gap-[14px] sm:gap-[18px] w-full lg:w-auto">

                            {offerings.map((item, index) => (
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, x: 20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{
                                        delay: index * 0.12,
                                        duration: 0.6,
                                    }}
                                    viewport={{ once: true }}
                                    whileHover={window.innerWidth >= 1024 ? { x: 10 } : {}}
                                    className="group flex items-start gap-[12px] cursor-pointer"
                                >

                                    <div className="shrink-0 pt-[2px]">
                                        <img src="/assets/lab/wrap1.svg" alt="" className="w-[14px] h-[14px] sm:w-auto sm:h-auto" />
                                    </div>
                                    <p className="text-[#49577A] text-[14px] lg:text-[16px] font-graphik font-[500] leading-[1.4] sm:leading-[16px] transition-all duration-300 group-hover:text-[#01386A]">
                                        {item}
                                    </p>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default ClientSection;